const videoEmbeds = [...document.querySelectorAll('.video_embed')]
const updateClasses = (parent, playing = false) => {
    console.log("click")
    if(!playing){
        parent.querySelector('.youtube-video').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        parent.querySelector(".video_control-play").classList.add("hidecontrol");
        parent.querySelector(".video_control-pause").classList.remove("hidecontrol");
        parent.querySelector(".video_control-stop")?.classList.remove("hidecontrol");
        parent.querySelector(".video_overlay").classList.add("hidden");
    } else {
        parent.querySelector('.youtube-video').contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        parent.querySelector(".video_control-pause").classList.add("hidecontrol");
        parent.querySelector(".video_control-play").classList.remove("hidecontrol");
        parent.querySelector(".video_control-stop")?.classList.remove("hidecontrol");
    }
} 

if (videoEmbeds.length) {
    videoEmbeds.forEach(videoEmbed => {
            videoEmbed.querySelector('.video_control-play').addEventListener('click', () => updateClasses(videoEmbed, false));
            videoEmbed.querySelector('.video_control-pause').addEventListener('click', () => updateClasses(videoEmbed, true));
            if(videoEmbed.classList.contains('js-videoSlider')) {
                videoEmbed.querySelector(".video_overlay").addEventListener('click', () => {
                    updateClasses(videoEmbed, false)
                }, { once:true })
            }
})
}